function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(1 1)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  stroke: "#416DE0",
  strokeWidth: 2,
  cx: 13,
  cy: 13,
  r: 13
}), React.createElement("path", {
  fill: "#416DE0",
  fillRule: "nonzero",
  d: "M18.544 13.968h-4.81v5.382H11.81v-5.382H7V12.2h4.81V7h1.924v5.2h4.81z"
}));

var SvgAdd = function SvgAdd(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 28 28"
  }, props), _ref);
};

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg viewBox='0 0 28 28' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cg id='rubrics' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg id='rubric_modal' transform='translate(-19.000000, -624.000000)'%3E %3Cg id='Group-5' transform='translate(20.000000, 625.000000)'%3E %3Ccircle id='Oval-Copy' stroke='%23416DE0' stroke-width='2' cx='13' cy='13' r='13'%3E%3C/circle%3E %3Cpolygon id='+-copy' fill='%23416DE0' fill-rule='nonzero' points='18.544 13.968 13.734 13.968 13.734 19.35 11.81 19.35 11.81 13.968 7 13.968 7 12.2 11.81 12.2 11.81 7 13.734 7 13.734 12.2 18.544 12.2'%3E%3C/polygon%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgAdd as ReactComponent };